module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/p0ztlD/tc-custom/9781439667989.jpg?1702529634826",
      "alt": "This image is the cover for the book Ghosts and Legends of Northern Ohio, Haunted America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ghosts and Legends of Northern Ohio, Haunted America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Hauntings and eerie tales abound in northern Ohio. Chillings legends, mysteries and hauntings.")])]), _c('br'), _c('p', [_vm._v("Does Esther Hale, believed to have been executed for witchcraft, really haunt Columbiana County's Bowman Cemetery? Is Lonesome Lock on the Ohio and Erie Canal as haunted as rumors say? Do restless spirits stalk the rooms at the Wolf Creek Tavern in Norton and the Rider's Inn of Painesville? Do the ruins of Gore Orphanage echo with the ghastly wails of children said to have died in a fire long ago? Author William G. Krejci guides this supernatural journey through the most chilling legends of northern Ohio. Some stories are debunked. Some long-standing mysteries are solved. Some new mysteries come to light.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William G. Krejci\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Born in Cleveland, William G. Krejci grew up in nearby Avon Lake. He works as a seasonal park ranger at Perry's Victory and International Peace Memorial at Put-in-Bay, Ohio. During the offseason, he is the resident historian at the Franklin Castle in Cleveland. He is the author of Buried Beneath Cleveland: Lost Cemeteries of Cuyahoga County and Haunted Put-in-Bay and coauthor of Haunted Franklin Castle. A guest speaker at various local historical societies, libraries, bookstores and civic groups, he's also appeared on SyFy's Ghost Hunters. In his free time, he sings and plays guitar in an Irish band.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0